export default __webpack_public_path__ + "static/media/info_section_secure.aa0b29b5.png";